import * as fromDatatype from '../datatype-library/index';

export interface bl_ppl_from_peppol_generic_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  from_peppol_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  classification: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  unit_price: fromDatatype.NumericDatatypeInterface;
  tax_type: fromDatatype.VarcharDatatypeInterface;
  tax_rate: fromDatatype.NumericDatatypeInterface;
  tax_amount: fromDatatype.NumericDatatypeInterface;
  tax_exemption_details: fromDatatype.VarcharDatatypeInterface;
  tax_exemption_amount: fromDatatype.NumericDatatypeInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  discount_rate: fromDatatype.NumericDatatypeInterface;
  discount_amount: fromDatatype.NumericDatatypeInterface;
  settlement_method: fromDatatype.VarcharDatatypeInterface;
  settlement_type: fromDatatype.VarcharDatatypeInterface;
  payment_terms: fromDatatype.VarcharDatatypeInterface;
  payment_amount: fromDatatype.NumericDatatypeInterface;
  payment_date: fromDatatype.TimestampTzDatatypeInterface;
  payment_reference_number: fromDatatype.VarcharDatatypeInterface;
  bill_reference_number: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_ppl_from_peppol_generic_doc_line_RowClass
  implements bl_ppl_from_peppol_generic_doc_line_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    from_peppol_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    classification: fromDatatype.VarcharDatatypeInterface;
    item_name: fromDatatype.VarcharDatatypeInterface;
    unit_price: fromDatatype.NumericDatatypeInterface;
    tax_type: fromDatatype.VarcharDatatypeInterface;
    tax_rate: fromDatatype.NumericDatatypeInterface;
    tax_amount: fromDatatype.NumericDatatypeInterface;
    tax_exemption_details: fromDatatype.VarcharDatatypeInterface;
    tax_exemption_amount: fromDatatype.NumericDatatypeInterface;
    qty: fromDatatype.NumericDatatypeInterface;
    uom: fromDatatype.VarcharDatatypeInterface;
    discount_rate: fromDatatype.NumericDatatypeInterface;
    discount_amount: fromDatatype.NumericDatatypeInterface;
    settlement_method: fromDatatype.VarcharDatatypeInterface;
    settlement_type: fromDatatype.VarcharDatatypeInterface;
    payment_terms: fromDatatype.VarcharDatatypeInterface;
    payment_amount: fromDatatype.NumericDatatypeInterface;
    payment_date: fromDatatype.TimestampTzDatatypeInterface;
    payment_reference_number: fromDatatype.VarcharDatatypeInterface;
    bill_reference_number: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}
